import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { ErrorService } from '../../services/error.service';
import { OpsService } from '../../services/ops.service';
import { GlobalMessageService } from '../../services/global-message.service';

@Component({
  selector: 'app-admin-system',
  templateUrl: './admin-system.component.html'
})
export class AdminSystemComponent implements OnInit {

  loadingPage = true;

  alertTiming: any[] = [];
  rawEmailStatus: any[] = [];
  customerEmailStatus: any[] = [];
  emailDetailStatus: any[] = [];
  batchqStatus: any[] = [];
  dataAge: any = {};

  constructor(private errorService: ErrorService,
              private opsService: OpsService,
              private globalMessageService: GlobalMessageService) { }

  ngOnInit() {
    this.initView();
  }

  private initView() {
    this.loadingPage = true;
    Observable.forkJoin(
      this.opsService.getAlertTimings(),
      this.opsService.getRawEmailStatus(),
      this.opsService.getCustomerEmailStatus(),
      this.opsService.getEmailDetailStatus(),
      this.opsService.getBatchqStatus(),
      this.opsService.dataAge()
    ).subscribe(
      (result: any) => {
        this.alertTiming = JSON.parse(result[0]);
        this.rawEmailStatus = JSON.parse(result[1]);
        this.customerEmailStatus = JSON.parse(result[2]);
        this.emailDetailStatus = JSON.parse(result[3]);
        this.batchqStatus = JSON.parse(result[4]);
        this.dataAge = result[5];

        var now = new Date();

        if (this.dataAge.raw_email) {
          this.dataAge.raw_age = (now.getTime() - new Date(this.dataAge.raw_email).getTime()) / 1000 / 60;
        }
        else {
          this.dataAge.raw_age = 0;
        }

        if (this.dataAge.customer_email) {
          this.dataAge.customer_age = (now.getTime() - new Date(this.dataAge.customer_email).getTime()) / 1000 / 60;
        }
        else {
          this.dataAge.customer_age = 0;
        }

        // if (this.dataAge.email_detail) {
        //   this.dataAge.ed_age = (now.getTime() - new Date(this.dataAge.email_detail).getTime()) / 1000 / 60;
        // }
        // else {
        //   this.dataAge.ed_age = 0;
        // }

        if (this.dataAge.batch_q) {
          this.dataAge.batchq_age = (now.getTime() - new Date(this.dataAge.batch_q).getTime()) / 1000 / 60;
        }
        else {
          this.dataAge.batchq_age = 0;
        }

        this.loadingPage = false;
      },
      error => {
        this.errorService.log(error, 'admin-account.component', 'initView');
        this.globalMessageService.error('Something bad!');
      }
    )
  }

}



// WEBPACK FOOTER //
// ./client/app/admin/admin-system/admin-system.component.ts